(function (Config, Constantes) {
    
    Config.defaultSitioId = Constantes.defaultSitioId;
    Config.apiVersion = Constantes.apiVersion;
    Config.cookieExpirationTime = Constantes.TimeExpiration;
    Config.keyPressLimit = Constantes.keyPressLimit;
    Config.freezeTime = Constantes.freezeTime;
    Config.returnBackInterval = Constantes.returnBackInterval;
    Config.dominioCookie = Constantes.dominioCookie || 'localhost';
    

    Config.disableValidations = Constantes.disableValidations;
    Config.enableQuickView = Constantes.enableQuickView;
    Config.forceCreateNewAddress = Constantes.forceCreateNewAddress;
    Config.elmahLevel = Constantes.elmahLevel;
    
    // =================================================
    // Dominios
    // =================================================
    Config.apiLoginUrl = Constantes.Dominios.apiLogin;
    Config.apiPaywallUrl = Constantes.Dominios.apiPaywall;
    Config.urlStatic = Constantes.Dominios.static;
    Config.defaultRedirectUrl = Constantes.Dominios.lanacion;
    Config.urlImages = Constantes.Dominios.static + "/images";
    Config.dominioMiCuenta = Constantes.Dominios.micuenta;
    Config.dominioLaNacion = Constantes.Dominios.lanacion;
    Config.urlPassport = Constantes.Dominios.passport;
    Config.urlMiClub = Constantes.Dominios.miclub;
    Config.urlBucket = Constantes.Dominios.bucket + '/Club.LN/anexos/fotos/productos/';
    Config.apiAuthorizeUrl = Constantes.Dominios.apiAuthorize;

    
    // =================================================
    // Api Keys
    // =================================================
    Config.wCentrixTime = Constantes.wCentrixTime;
    Config.idWcentrix = Constantes.idWcentrix;
    Config.hotjarId = Constantes.idHotjar;
    Config.fbId = Constantes.fbId;
    Config.gmId = Constantes.gmId;
    Config.gmRedirect = Constantes.gmRedirect;
    Config.rcId = Constantes.rcId;
    Config.gaId = Constantes.gaId;
    Config.gtmId = Constantes.gtmId;
    Config.SentryPaywall = Constantes.sentry_paywall || null;
    Config.SentryIngresar = Constantes.sentry_ingresar || null;

     // =================================================
    // Apple Keys
    // =================================================
    Config.appleClientId = Constantes.appleClientId;
    Config.appleScope = Constantes.appleScope;
    Config.appleRedirectUri = Constantes.appleRedirectUri;
    Config.appleState = Constantes.appleState;
    Config.appleNonce = Constantes.appleNonce;

    // ==================================================
    // Sitios Ids Asociar Tarjeta post-login
    // 6 - Club LN / 7 - Autogestión/MiClub
    // ==================================================  
    Config.SitiosAsociarCredencial = Object.values(Constantes.SitiosAsociarCredencial);

    // ==================================================
    // Sitios Ids Permitidos
    // 1 - webLN / 2 - webCLL / 3 - webOH / 4 - appLN / 6 - Club LN / 7 - Autogestión/MiClub / 8 - Experiencias Black
    // ==================================================
    Config.Sitios = Constantes.Sitios;

    // ==================================================
    // Dominios permitidos a redireccionar
    // ==================================================  
    Config.dominiosPermitidos = RegExp(Constantes.dominiosPermitidos);

    // ========================================================
    // Diccionario de keys de usuario para grabar en cookies
    // ========================================================
    Config.DiccionarioCookiesAGuardar = Object.values(Constantes.DiccionarioCookiesAGuardar);

    if (Constantes.AdditionalQueryStrParam) {
        Config.AdditionalQueryStrParam = Object.values(Constantes.AdditionalQueryStrParam);
    }

    // ========================================================
    // Api authorize
    // ========================================================
    Config.apiAuthorizeInfo = {
        cookieExpirationTime: Config.cookieExpirationTime,
        dominioCookie: Config.dominioCookie,
        CookiesMetering: Constantes.CookiesMetering
    };

})(LN.Config, window.config.Constantes);


// WEBPACK FOOTER //
// ./Statics/scripts/common/config.js